import { toolTip } from "../../controls/toolTip";
import { ll } from "../../core/ll";
import { buildDataBindSyntax } from "../buildDataBindSyntax";
import K_EditableLabelGroup from "../templates/K_EditableLabelGroup";
import { Component, ComponentOptions } from "./component";
import { TemplateComponent } from "./templateComponent";

export interface EditableLabelGroupOptions extends ComponentOptions {
    components?: Component[];
    linkId?: string;
    linkClasses?: string;
    headerLabelBind?: string;
    toolTip?: string;
    href?: string;
    iconId?: string;
    iconType?: string;
    iconClasses?: string;
    showLabelLabel?: boolean | "true";
    bsc?: string;
}

export class EditableLabelGroup extends TemplateComponent {

    options: EditableLabelGroupOptions;
    content: {
        components: Component[];
    };

    constructor(options: EditableLabelGroupOptions) {
        super(K_EditableLabelGroup, options);

        this.content = {
            components: options.components || []
        };
    }

    preRender() {
        const options = this.options;

        options.containerClasses = options.containerClasses || "";
        options.linkId = options.linkId || options.id + "_Edit";
        options.iconType = options.iconType || "";
        options.iconClasses = options.iconClasses || "";
        options.iconId = options.iconId || "";
        options.headerLabelBind = buildDataBindSyntax(options.headerLabelBind, "label");
        options.toolTip = ll(options.toolTip);
    }

    create() {
        const args = this.options;

        var parent = $("#" + args.id);
        if (args.showLabelLabel) {
            parent.addClass("display-label-label");
            parent.find(".display-label").hide();
            parent.find(".editable-input-container").show();
            parent.find(".editable-input").readOnly(true);
            $("#" + args.linkId).tie("click", function () {
                if (parent.hasClass("disabled")) {
                    return;
                }

                parent.addClass("editing");
                parent.find(".editable-input").readOnly(false);
                parent.find(".editable-input:first:not([disabled])").focus();
                $.each(parent.find("[data-z-role]"), function (index, elem) {
                    elem = $(elem);
                    var dataRole = elem.data("zRole");
                    var role = elem.data("kendo" + dataRole);
                    if (role) {
                        elem.removeAttr("style");
                        role.destroy && role.destroy();
                    }
                    $(elem)["kendo" + dataRole]({});
                });
            });
            $("#" + args.id).tie("focusout", ".editable-input", function () {
                $.wait(100).then(function () {
                    if (parent.find(".editable-input:focus").length == 0) {
                        parent.find(".editable-input").readOnly(true);
                        parent.removeClass("editing");
                    }
                });
            });

            $("#" + args.id).tie("focusout", ".editable-input", function () {
                var data = $(this).data();
                var value = $(this).val();
                var bindText = data.bind || "";
                var bindData = data.bindData;
                var index = bindText.indexOf(":");
                var bindField = bindText.slice(index + 2);

                if (data && data.zRole == "DateTimePicker") {
                    if ($(this).data("kendoDateTimePicker") && $(this).data("kendoDateTimePicker").value()) {
                        value = $(this).data("kendoDateTimePicker").value();
                        bindData && bindData.set(bindField, value.toISOString());
                    }
                } else {
                    bindData && bindData.set(bindField, null);
                    bindData && bindData.set(bindField, value);
                }
            });

            $("#" + args.id).tie("focus", ".editable-input", function () {
                var data = $(this).data();
                var bindText = data.bind || "";
                var bindData = data.bindData;
                var index = bindText.indexOf(":");
                var bindField = bindText.slice(index + 2);

                var value = bindData && bindData.get(bindField);

                if (data && data.zRole == "DateTimePicker") {
                    return;
                }
                if ($(this).find("[data-z-role='DateTimePicker']").length) {
                    return;
                }
                if (!value) {
                    $(this).val("");
                }
            });

        } else {
            $("#" + args.linkId).tie("click", function () {
                if (parent.hasClass("disabled")) {
                    return;
                }

                parent.find(".display-label").hide();
                parent.find(".editable-input-container").show();
                parent.find(".editable-input:first:not([disabled])").focus();
                $.each(parent.find("[data-z-role]"), function (index, elem) {
                    elem = $(elem);
                    var dataRole = elem.data("zRole");
                    var role = elem.data("kendo" + dataRole);
                    if (role) {
                        elem.removeAttr("style");
                        role.destroy && role.destroy();
                    }
                    $(elem)["kendo" + dataRole]({});
                });
            });
            $("#" + args.id).tie("focusout", ".editable-input", function () {
                $.wait(100).then(function () {
                    if (parent.find(".editable-input:focus").length == 0) {
                        parent.find(".editable-input-container").hide();
                        $.each(parent.find(".display-label"), function (index, label) {
                            var labelValue = $(label).text();
                            if ($.trim(labelValue)) {
                                $(label).show();
                            }
                        });
                        parent.removeClass("editing");
                    }
                });
            });
        }

        $("#" + args.id).tie("click", ".editable-input, .display-label", function () {
            if (parent.hasClass("disabled")) {
                return;
            }

            if (parent.hasClass("editing")) {
                return;
            }
            parent.addClass("editing");
            parent.find(".display-label").hide();
            parent.find(".editable-input-container").show();
            parent.find(".editable-input").readOnly(false);
            $.each(parent.find("[data-z-role]"), function (index, elem) {
                elem = $(elem);
                var dataRole = elem.data("zRole");
                var role = elem.data("kendo" + dataRole);
                if (role) {
                    elem.removeAttr("style");
                    role.destroy && role.destroy();
                }
                $(elem)["kendo" + dataRole]({});
            });
            if (parent.find(".editable-input:focus").length == 0) {
                parent.find(".editable-input:first:not([disabled])").focus();
            }
        });

        if (this.options.toolTip) {
            toolTip({
                selector: $("#" + this.id + "_Edit")
            });
        }
    }

}
